// 量比是衡量相对成交量的指标。
// 它是指股市开市后平均每分钟的成交量与过去5个交易日平均每分钟成交量之比。
// 其计算公式为：量比=（现成交总手数 / 现累计开市时间(分) ）/ 过去5日平均每分钟成交量 [1]  。
import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import { checkFootAuth, checkFootTitleAuth } from '../dectorator/checkauthdectorator/index.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
import { checkExchange } from '../../controller/util.js';
import { LINE_TYPE } from '../setting.js';
const model = {
    liangbi: {
        type: Array,
        Default: () => ([])
    }
};
export default class LIANGBIState extends FootDectorator(BaseContext){
    constructor({data, ...rest}) {
        super({...rest, data: mergeModelData(model, data)});
      }





    }

